module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box column"
  }, [_c('h1', {
    staticClass: "main"
  }, [_vm._v("\n      個人情報保護方針"), _c('br'), _vm._v("\n      Privacy Policy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n      株式会社トリプルバリュー（以下、「当社」といいます。）は、経営コンサルティング、企業研修、エンゲージメントカード販売などで事業を展開しています。当社が取り扱う個人情報について、適切に取得、利用及び提供を行うため、個人情報の保護に関する法律その他関連法令を遵守するとともに、本個人情報保護方針を定め、個人情報管理体制を確立し、企業として責任ある対応を実現するものとします。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("法令、規範の遵守")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、個人情報の取扱いに関する法令、国が定める指針その他の規範を遵守します。そのため、日本工業規格「個人情報保護マネジメントシステム — 要求事項」(JIS Q 15001)に準拠した個人情報保護マネジメントシステムを策定し、適切に運用いたします。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("個人情報の安全対策")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、個人情報の正確性及び安全性確保のために、個人情報の漏えい、滅失又はき損の防止及び是正のための適切な措置を講じます。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("目的外利用の禁止")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、事業の内容及び規模を考慮した適切な個人情報の取得、利用及び提供を行います。それには特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行わないこと及びそのための措置を講じることを含みます。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("個人情報取扱の委託")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、個人情報の取扱いの全部又は一部を委託する場合は、その取扱いを委託された個人情報の安全管理が図られるよう、委託を受けた者に対する必要かつ適切な監督を行います。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("苦情・相談に対する適切な対応")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、個人情報の取扱いに関する苦情及び相談への適切かつ迅速な対応に努めます。また、当社が保有する保有個人データの開示等の請求等(利用目的の通知、開示、訂正・追加又は削除、利用又は提供の停止）を受け付けます。開示等の求めの手続きにつきましては、「個人情報苦情および相談窓口」までご連絡ください。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("見直し及び改善")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、本個人情報保護方針の内容を適宜見直すとともに、個人情報保護マネジメントシステムの継続的改善に努めます。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "main"
  }, [_vm._v("個人情報苦情および相談窓口")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        〒532-0011"), _c('br'), _vm._v("\n        大阪府大阪市淀川区西中島6-3-32 第2新大阪ビル7F"), _c('br'), _vm._v("\n        株式会社トリプルバリュー"), _c('br'), _c('br'), _vm._v("\n        個人情報保護管理者：代表取締役　山本龍太"), _c('br'), _vm._v("\n        e-mail：info@triplevalue.jp"), _c('br'), _vm._v("\n        (受付時間 月曜日～金曜日 祝祭日を除く 10時～17時)\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "signature"
  }, [_vm._v("\n        制定：2022年6月1日"), _c('br'), _vm._v("\n        株式会社トリプルバリュー"), _c('br'), _vm._v("\n        代表取締役 山本龍太\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e726c08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/PrivacyPolicy.vue
// module id = 889
// module chunks = 1